/*
 * Copyright (c) 2014-2023 Comparatio
 */

export const environment = {
  production: true,
  development: false,
  test: false,
  'API_URL': 'https://edi.comparatio.com',
  'secondsTokenExpire': 60, // time in seconds to notify user before token will expire
  'smallScreenThreshold': 1192,
  'guestUserId': 560
};

export const fiveDecCompanies = {
  key: [125, 139]
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/environments/environment.ts